import React from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

export default function Checkout() {
  const navigate = useNavigate();
  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-24 flex items-center justify-center">
      <div className="max-w-xl text-center px-6">
        <h1 className="text-4xl mb-4" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
          Tunnel de paiement
        </h1>
        <div className="gold-divider mb-6" />
        <p className="text-gray-400 mb-8">
          Les paiements se font directement lors de la réservation ou de l'achat d'une carte cadeau.
          Veuillez utiliser les pages dédiées.
        </p>
        <button onClick={() => navigate('/')} className="btn-gold-filled">
          <Home size={16} />
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
}
